import React, { FunctionComponent } from 'react'

import Text from '../Text'
import { IRadioProps } from './RadioComponent.types'
import { Indicator, Input, Label } from './styles'

const RadioButton: FunctionComponent<IRadioProps> = ({
  value,
  onChange,
  name,
  id,
  label,
  disabled,
  checked,
  textColor,
  borderColor,
  indicatorColor,
  textWeight,
}) => {
  return (
    <Label htmlFor={id} disabled={disabled} $borderColor={borderColor}>
      <Text weight={textWeight ?? 'bold'} color={textColor}>
        {label}
      </Text>
      <Input
        id={id}
        type="radio"
        role="radio"
        name={name}
        value={value}
        disabled={disabled}
        onChange={e => {
          onChange(e.target.value)
        }}
        checked={checked}
      />
      <Indicator color={indicatorColor} />
    </Label>
  )
}

export default RadioButton
